<mat-card appearance="outlined">
  <h2>{{'dynamicContent.activity.title' | translate}}</h2>
  <div class="field double">
    <ibex-checkbox [title]="'dynamicContent.activity.repeating' | translate" (click)="dynamicContent.content.repeating = $event.val"></ibex-checkbox>
    <smart-input *ngIf="dynamicContent.content.repeating" [model]="dynamicContent.content" [key]="'rhythm'"
                 [hideDescription]="true" translationPrefix="dynamicContent.activity"></smart-input>
  </div>

  <ng-container *ngIf="!dynamicContent.content.repeating || (dynamicContent.content.repeating && dynamicContent.content.rhythm)">
    <ng-container *ngIf="dynamicContent.content.rhythm" [ngSwitch]="dynamicContent.content.rhythm">
      <div *ngSwitchCase="'yearly'" class="field single">
        <smart-input [model]="dynamicContent.content" key="date" translationKey="dynamicContent.activity.date" [hideDescription]="true"
                     format="dd-mm"></smart-input>
      </div>
      <ng-container *ngSwitchCase="'monthly'">
        <smart-input [model]="dynamicContent.content" key="date" translationKey="dynamicContent.activity.date" [hideDescription]="true"
                     format="dd"></smart-input>
      </ng-container>
      <ng-container *ngSwitchCase="'weekly'">
        <div class="days-container">
          <ibex-checkbox *ngFor="let i of weekdayArray" (click)="updateWeekdays(i)" [title]="'general.days.' + i | translate" [checked]="weekdays[i]"></ibex-checkbox>
        </div>
      </ng-container>
    </ng-container>
    <smart-input *ngIf="!dynamicContent.content.rhythm" [model]="dynamicContent.content" key="date"
                 translationKey="dynamicContent.activity.date" [hideDescription]="true"></smart-input>
  </ng-container>
  <div class="field double">
    <smart-input [model]="dynamicContent.content" key="startTime" translationKey="dynamicContent.startTime"
                 [hideDescription]="true"></smart-input>
    <smart-input [model]="dynamicContent.content" key="endTime" translationKey="dynamicContent.endTime"
                 [hideDescription]="true"></smart-input>
  </div>
  <mat-form-field *ngIf="categories?.length">
    <mat-select [(ngModel)]="dynamicContent.content.categories" multiple placeholder="{{'dynamicContent.categories' | translate}}">
      <mat-option *ngFor="let category of categories" [value]="category._id">{{category.title}}</mat-option>
    </mat-select>
  </mat-form-field>
</mat-card>
